import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom';

const IntroTopSection = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const handleTabClick = (tabName) => {
        // Handle tab navigation
        navigate(`/${tabName}`);
    };


    return (
        <>

            {/* Hero Section */}
            <section className="hero-section">
                <div className="hero-image hero-background">
                    <div className="hero-overlay">
                        <div className="hero-content">
                            <div className="hero-yellow-line"></div>
                            <h1 className="hero-title">추모원 소개</h1>
                        </div>
                    </div>
                </div>
            </section>


            {/* Sub Navigation */}
            <section className="sub-navigation">
                <div className="tab-container">
                    <a
                        className={`tab-link ${location.pathname.includes('ceo-greeting') ? 'active' : ''}`}
                        onClick={(e) => {
                            handleTabClick('ceo-greeting');
                        }}
                    >
                        대표인사 인사말
                    </a>
                    <a
                        className={`tab-link ${location.pathname.includes('introduction-memorial') ? 'active' : ''}`}
                        onClick={(e) => {
                            handleTabClick('introduction-memorial');
                        }}
                    >
                        추모원 소개
                    </a>
                    <a
                        className={`tab-link ${location.pathname.includes('facilities') ? 'active' : ''}`}
                        onClick={(e) => {
                            handleTabClick('facilities');
                        }}
                    >
                        시설안내
                    </a>
                    <a
                        className={`tab-link ${location.pathname.includes('memorial-gallery-list') || location.pathname.includes('memorial-gallery-details') ? 'active' : ''}`}
                        onClick={(e) => {
                            handleTabClick('memorial-gallery-list');
                        }}
                    >
                        추모원 갤러리
                    </a>
                    <a
                        className={`tab-link ${location.pathname.includes('directions') ? 'active' : ''}`}
                        onClick={(e) => {
                            handleTabClick('directions');
                        }}
                    >
                        오시는 길
                    </a>
                </div>
            </section>

        </>
    )
}

export default IntroTopSection;